import { API } from "./Interceptor";

export const updateUserStatus = async (status, projectId, userId) => {
  const payload = {
    status: status,
    jobId: projectId,
    userId: userId,
  };
  try {
    const res = await API.put("api/jobs/status", payload);
    return res?.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};
